import axios from 'axios';

//	Constants
import { API_VERSION } from '../data/constants';

const HOST =
	process.env.NODE_ENV === 'development'
		? process.env.REACT_APP_DEV_SERVER_URL
		: process.env.REACT_APP_PROD_SERVER_URL;

const fetchProjects = async (page, limit) => {
	const response = await axios.get(
		`${HOST}/api/${API_VERSION}/projects?page=${page}&limit=${limit}`
	);
	return response;
};

const fetchProject = async id => {
	const response = await axios.get(`${HOST}/api/${API_VERSION}/projects/${id}`);
	return response;
};

const projectsAPI = {
	fetchProjects,
	fetchProject,
};

export default projectsAPI;
